var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"操作类型","prop":"operationDesc"}}),_c('el-table-column',{attrs:{"label":"操作时间","prop":"createTime","formatter":_vm.formatter}}),_c('el-table-column',{attrs:{"label":"IP地址/备注","prop":"otherField"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }